export function openPopup(state, { type, data }) {
  return {
    ...state,
    ui: {
      popup: {
        type,
        data,
      },
    },
  };
}

export function closePopup(state, { type }) {
  return {
    ...state,
    ui: {
      popup: {
        type: null,
        data: {},
      },
    },
  };
}



/** WEBPACK FOOTER **
 ** ./js/core/ui.js
 **/